import { useCurrentUser } from "./useCurrentUser";
import { agentRoles } from "../constants/agent";
import { useSelectedCompany } from "../context/SelectedCompanyContext";


export const useReportCompanyParam = (): { company_id?: number } => {
    const user = useCurrentUser();
    const { selectedCompany } = useSelectedCompany();
    const isSuperAdmin = user?.agent_role === agentRoles.super_admin;
    return isSuperAdmin && selectedCompany
        ? { company_id: selectedCompany.id }
        : {};
};
